import './SpeechBubble.css';

function inferRingLabel(meshName = '', planetName = '') {
  const ringTypes = ['Inner', 'Main', 'Outer'];
  const meshNameLower = meshName.toLowerCase();

  const found = ringTypes.find(type =>
    meshNameLower.includes(type.toLowerCase())
  );

  return found ? `${planetName} - ${found} Ring` : ``;
}

export function PlanetLabel(planetName, meshName = '') {
  const ringNameMap = {
    Jupiter: {
      Inner_Ring: 'Inner Ring - Halo Ring',
      Main_Ring: 'Main Ring - Main Ring',
      Outer_Ring: 'Outer Ring - Gossamar Ring',
    },
    Saturn: {
      Inner_Ring: 'Inner Rings - (Rings D, C, B)',
      Main_Ring: 'Main Rings - (Cassini Division & Ring A)',
      Outer_Ring: 'Outer Rings - (Rings F, G, E)',
    },
    Uranus: {
      Inner_Ring: 'Inner Rings - (Zeta Ring, Rings 6, 5, 4)',
      Main_Division: 'Main Rings - (Eta, Alpha, Beta, Gamma, Delta, Epsilon Ring)',
      Outer_Diffuse: 'Outer Rings - (Mu & Nu Ring)',
    },
     Neptune: {
      Inner_Ring: 'Inner Ring - Adams Ring',
      Main_Ring: 'Main Rings - (Le Verrier & Galle Rings)',
      Outer_Ring: 'Outer Ring - Arago Ring',
    },
  };

  const known = ringNameMap[planetName];
  const meshNameLower = meshName.toLowerCase();

  if (known) {
    // Exact match
    if (Object.prototype.hasOwnProperty.call(known, meshName)) {
      return known[meshName];
    }

    // Fuzzy match
    const fuzzyKey = Object.keys(known).find(key =>
      meshNameLower.includes(key.toLowerCase())
    );
    if (fuzzyKey) {
      return known[fuzzyKey];
    }
  }
  return inferRingLabel(meshName, planetName);
}

export default function SpeechBubble({ label, isOpen}) {
  if (!label) return null;
  return (
     <div className="speech-bubble">
      <div
         className={`bubble-wrapper ${isOpen ? 'open' : 'close'}`}
        style={{ '--bubble-height': '3rem' }}
      >
        <div className="bubble-mask top" />
        <div className="bubble-label">{label}</div>
        <div className="bubble-mask bottom" />
      </div>
    </div>
  );
}
